import Locations from '@components/Items/Filters/Active/Locations'
import Conditions from '@components/Items/Filters/Active/Conditions'
import EndDates from '@components/Items/Filters/Active/EndDates'
import PickUpDates from '@components/Items/Filters/Active/PickUpDates'
import Clear from '@components/Items/Filters/Active/Clear'
import Categories from '@components/Items/Filters/Active/Categories'
import BidftaPlus from '@components/Items/Filters/Active/BidftaPlus'
import NumberOfUniqueBidders from '@components/Items/Filters/Active/NumberOfUniqueBidders'

const Active = () => {
  return (
    <div className="flex flex-row flex-wrap gap-1 max-h-24 overflow-auto">
      <Clear />
      <Locations />
      <Conditions />
      <Categories />
      <PickUpDates />
      <EndDates />
      <BidftaPlus />
      <NumberOfUniqueBidders />
    </div>
  )
}

export default Active
